export default __webpack_public_path__ + "static/pic2-8e367351ccc2e31f5c8883e8b00e77d8.jpg";